import { heightAtLatLng } from "../../utils/mapping-functions";
import SETTINGS from "../../settings";

const Paths = (props) => {
  let paths = [];
  const heightMap = props.heightMap;
  const roads = props.heightMap.roads;
  const size = heightMap.boundBox.size;
  const min = heightMap.heightLimits.min;
  const scale = SETTINGS.TERRAIN.SCALE;

  if (roads.length > 0) {
    for (let i = 0; i < roads.length; i++) {
      let roadPosition = [];
      for (let j = 0; j < roads[i].positionsArray.length; j++) {
        if (heightMap.boundBox.isPointWithin(roads[i].positionsArray[j])) {
          const point = heightAtLatLng(roads[i].positionsArray[j], heightMap);
          roadPosition.push(
            new THREE.Vector3(
              (point.x * size.x - size.x / 2) / scale,
              (point.z - min) / scale,
              (point.y * size.y - size.y / 2) / scale
            )
          );
        }
      }
      paths.push(roadPosition);
    }
  }
  return (
    <group>
      {paths.map((road, i) => {
        return (
          <line key={i} position={[0, 0.0, 0]}>
            <geometry
              attach="geometry"
              vertices={road}
              onUpdate={(self) => (self.verticesNeedUpdate = true)}
            />
            <lineBasicMaterial attach="material" color={0xaaaaaa} />
          </line>
        );
      })}
    </group>
  );
};

export default React.memo(Paths);
